export const ctaSubmitStyle = `w-full min-w-[187.562px] py-1.5 text-xl border font-bold hover:bg-[#0E1116] hover:text-white border-gray-700 dark:border-gray-700 rounded-b`

export const lineProps = () => ({
  style: { display: 'block', cursor: 'pointer' },
})
